import {
  call, put, takeLatest,
} from 'redux-saga/effects';
import MetricsService from '../service';
import {
  showMetrics,
  showMetricsError,
} from '../actions';
import actions from '../constants';

async function fetchMetrics(entities) {
  return MetricsService.metrics(entities)
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
}

export function* metrics(action) {
  const { response, error } = yield call(fetchMetrics, action.entities);

  if (error) {
    yield put(showMetricsError(error));
  } else {
    yield put(showMetrics(response));
  }
}

export default function* metricsApi() {
  yield takeLatest(actions.FETCH_METRICS, metrics);
}
